const taskTemplates = require('../../task-templates');

const tasksData = [
	/* case 1 */
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'it-spot-errors-does-not-belong',
		layout: 'it-does-not-belong',
		text: `Marker de 5 ting som ikke hører hjemme i IT afdelingen.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'wire'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'safety-glasses'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'drone'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'lamp'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'ash-tray'}),
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'it-input-answer-computer-budget',
		text: `Computerne skal udskiftes om 5 år og koster 320.000 kr.
			<br /><br />Hvor meget skal der afsættes hvert år i budgettet, så pengene er klar?`,
		answer: 64000,
		unit: 'kr.',
		hintText: `Divider den samlede pris med antallet af år, computerne skal holde.`,
		popupText: `På HHX arbejder man med budgetter og planlægning af fremtidige udgifter.`,
		image: null
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		taskId: 'it-sort-personal-data-risk',
		title: 'Opgave 3',
		text: `Sorter de følgende situationer alt efter, om I tror de udgør en acceptabel eller kritisk risiko for persondata.`,
		hintText: `Kig på om data er sikret, og hvem der har adgang.`,
		popupText: `Det her er noget, man arbejder med, når man lærer om ansvar og datasikkerhed på HHX.`,
		layout: 'double-height',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'acceptable', 
				title: `Acceptabel risiko`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'critical', 
				title: `Kritisk risiko `
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Medarbejdernes CPR numre og kontonumre registreres i et sikkert IT system`,
				categoryIds: ['acceptable']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Vi har en liste med kunders mail og telefonnumre liggende frit fremme på kontoret`,
				categoryIds: ['critical']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Vi har kontrakter gemt sikkert i et digitalt arkiv med begrænset adgang`,
				categoryIds: ['acceptable']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Vi har kundedata liggende på en privat computer uden adgangskode`,
				categoryIds: ['critical']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		title: 'Opgave 4',
		taskId: 'it-multiple-choice-data-role',
		text: `Når I indsamler data om kunder, hvad er så jeres ansvar i forhold til dataen?`,
		hintText: `Når virksomheden bestemmer, hvad data bruges til, og hvordan de opbevares, har den ansvaret.`,
		popupText: null,
		image: 'hhx-it-data-safety-4',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Vi er dataansvarlige', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Vi er registrerede'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Vi er rettighedshaver',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Vi er en cookie'
			})
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 5,
		title: 'Opgave 5',
		taskId: 'it-input-answer-pin-codes',
		text: `I har fire-cifrede pinkoder på jeres computere. 
			<br /><br /><b>Hvor mange forskellige mulige koder giver det?</b>`,
		answer: 10000,
		unit: 'forskellige koder',
		hintText: `Der er <b>10 muligheder for hvert tal</b> – og koden består af fire tal.
			<br /><br /><b>Gang mulighederne</b> for hvert af de fire cifre med hinanden.`,
		image: 'hhx-it-data-safety-5',
	}),
	// Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 1,
	// 	taskId: 'it-order-robot-tea',
	// 	title: 'Opgave 1',
	// 	text: 'Forestil dig, at du skal få en robot til at lave en kop te. Husk: En robot udfører nøjagtigt det du beder den om, hverken mere eller mindre. Sæt kommandoerne i den korrekte rækkefølge.',
	// 	items: [
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'lift-kettle', 
	// 			text: `Løft elkoger`,
	// 			correctOrderNumbers: [1, 9]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'move', 
	// 			text: `Flyt elkoger hen under vandhanen`,
	// 			correctOrderNumbers: [2]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'turn-on-water', 
	// 			text: `Tænd vandet`,
	// 			correctOrderNumbers: [3]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'turn-off-water', 
	// 			text: `Sluk vandet når elkoger er fyldt`,
	// 			correctOrderNumbers: [4]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'move-kettle-to-correct-place', 
	// 			text: `Sæt elkoger på plads`,
	// 			correctOrderNumbers: [5]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'turn-on-kettle', 
	// 			text: `Tænd elkogeren`,
	// 			correctOrderNumbers: [6]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'take-the', 
	// 			text: `Tag fat i te-brev`,
	// 			correctOrderNumbers: [7]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'place-the-into-kop', 
	// 			text: `Put te-brev i kop`,
	// 			correctOrderNumbers: [8]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'lift-kettle-again', 
	// 			text: `Løft elkoger`,
	// 			correctOrderNumbers: [9, 1]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'pour-the-water-on-top', 
	// 			text: `Hæld vand fra elkoger i kop`,
	// 			correctOrderNumbers: [10]
	// 		}),
	// 	]
	// }),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 2,
	// 	title: 'Opgave 2',
	// 	taskId: 'it-multiple-choice-robot-typical-jobs',
	// 	text: `Robotter er kun gode til nogle typer af opgaver. Hvilke tre opgaver har robotter typisk på en fabrik?`,
	// 	popupText: null,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Montage', 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Skæring',
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Opsamling og pakning',
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Inspektion'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: 'Syning',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6,
	// 			text: 'Varierede opgaver'
	// 		})
	// 	],
	// }),
	/* Case 2 */
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1A',
	// 	taskId: 'it-multiple-choice-design-colors',
	// 	text: `Kig på designguiden. Hvilke to farver tror I ledelsen har valgt til den nye hjemmeside?`,
	// 	popupText: null,
	// 	files: [
	// 		{
	// 			id: 'color-guide',
	// 			type: 'image',
	// 			btnText: 'Se designguide',
	// 		}		
	// 	],
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1, text: 'Orange', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2, text: 'Blå'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3, text: 'Rosa',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4, text: 'Violet'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5, text: 'Gul',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6, text: 'Turkis ', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 7, text: 'Rød'
	// 		})
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'it-website-1a',
		text: `<b>Kig på farverne og deres betydning</b>.
			<br /><br />Hvilke to farver tror I bedst passer til virksomhedens nye hjemmeside?`,
		hintText: `Målet er at virke professionel og troværdig.`,
		subtype: 'images',			
		layout: 'it-colors',
		image: 'hhx-it-website-1',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'blue', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'grey', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'yellow'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'purple'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'green'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'red'
			})
		]
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 1.3,
	// 	subtype: 'images',
	// 	title: 'Opgave 1B',
	// 	taskId: 'it-multiple-choice-design-font',
	// 	lockedById: 'it-multiple-choice-design-colors',
	// 	text: `Hvilken font er den mest brugte hjemmeside font?`,
	// 	layout: 'it-fonts',
	// 	popupText: null,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'arial', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'roboto'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'times',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'calibri'
	// 		})
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		title: 'Opgave 1B',
		taskId: 'it-website-1b',
		lockedById: 'it-website-1a',
		text: `Hvilken URL passer bedst til den danske hjemmeside?
			<br /><br /><b>I kan kun vælge én</b>.`,
		showNumberOfAnswersToSelect: false,
		popupText: null,
		hintText: `Bindestreger er ikke gode i hjemmesider, og com er bedre til salg over landegrænsen.`,
		image: 'hhx-it-website-1b',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'www&period;futurebusiness&period;dk', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'www&period;futurebusiness&period;com'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'www&period;future-business&period;com',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'www&period;future-business&period;dk'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'www&period;futurebusiness&period;nu'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'www&period;future-business&period;nu'
			})
		],
	}),
	/* Case 3 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'it-goals-1',
		text: `<b>Ledelsen skal vælge klare mål for virksomheden</b>. 
			<br /><br />Hvilke tre er vigtigst at fokusere på først?`,
		hintText: `De første mål skal sikre, at virksomheden <b>tjener penge, leverer kvalitet</b> og har <b>tilfredse kunder</b> - ikke store visioner langt ude i fremtiden.`,
		image: 'hhx-it-goals-1',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Øge overskuddet mest muligt', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Blive mere kendte',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Vores kunder skal altid være tilfredse', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Udvide til udlandet'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Vi vil være de bedste til det vi laver', isCorrect: true
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'it-goals-2',
		text: `Et nyttigt redskab for ledelsen kan være at lave en såkaldt <b>SWOT-analyse</b>. 
			<br /><br />Hvad står det for?`,
		hintText: `Det er fire ord, der handler om <b>styrker, svagheder, muligheder</b> og <b>trusler</b>.`,
		popupText: `<b>SWOT</b> er et klassisk analyseværktøj, som man lærer at bruge på HHX.`,
		image: 'hhx-it-goals-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Strengths, Weaknesses, Opportunities, Threats', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Stakes, Wins, Open doors, Trouble',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Speak With Open Tongues',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Sales, Work, Output, Trends',
			}),
		],
	}),
	/* Case 4 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		title: 'Opgave 1A',
		taskId: 'it-rights-1a',
		text: `Hvad kan konsekvensen være, hvis en virksomhed krænker andres rettigheder?`,
		hintText: `Det kan ende med krav om erstatning, retssager eller at virksomheden bliver tvunget til at stoppe med løsningen.`,
		popupText: `Det her viser, at valg i en virksomhed kan få reelle konsekvenser - noget man også lærer på HHX.`,
		shuffleOptions: false,
		multiline: 'off',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'At betale erstatning', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'At stoppe brugen af løsningen',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'At fjerne løsningen fra markedet',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'At betale en bøde',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Fængsel i op til 1,5 år',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'Alle ovenstående',
				isCorrect: true,
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		title: 'Opgave 1B',
		taskId: 'it-rights-1b',
		lockedById: 'it-rights-1a',
		text: `<b>Jeres jurister vurderer, at jeres løsning minder meget om en konkurrent</b>.
			<br /><br />Hvilke to handlinger er mest fornuftige nu?`,
		hintText: `Det mest fornuftige er at justere løsningen og få juridisk afklaring, før I går videre.`,
		image: 'hhx-it-rights-1b',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'At stoppe arbejdet med løsningen', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'At kontakte konkurrenten og afklare rettigheder',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'At fortsætte arbejdet uden ændringer',
			})
		],
	}),
	/* Case 5 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'it-unexpected-events-1',
		text: `<b>I læser, at Storebæltsbroen er spærret hele dagen</b>.
			<br /><br />En vigtig leverance til virksomheden bliver derfor mindst 12 timer forsinket.
			<br /><br /><b>Hvad er det rigtige at gøre?</b>`,
		hintText: `I kan ikke ændre situationen her og nu, men I kan vælge at bruge tiden bedst muligt, mens I venter.`,
		isDilemma: true,
		numberOfAnswersToSelect: 1,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Forsøge at få åbnet broen',
				points: 0
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Lade medarbejderne bruge tiden på andre opgaver',
				points: 100
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Prøve at finde en anden distributør i nærheden',
				points: 60
			}),
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'it-unexpected-events-2',
		text: `<b>Vigtigt IT-udstyr går pludselig i stykker</b>.
			<br /><br />Leverandøren anbefaler at udskifte to ens dele.
			<br /><br />Prisen for én del er <b>1.250 kr. inkl. moms</b>.
			<br />Virksomheden får momsen retur.
			<br /><br /><b>Hvad bliver den samlede pris for begge ekskl. moms?</b>`,
		hintText: `Divider prisen med 1,25 for at fjerne momsen.`,
		popupText: `Det her er praktisk regning med moms, som man lærer at bruge på HHX.`,
		answer: 2000,
		unit: 'kr.',
		image: 'hhx-it-unexpected-events-2'
	}),
	/* Case 6 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'it-employees-1',
		text: `<b>En medarbejder har lavet en fejl i en kundeaftale</b>.
			<br /><br /><Hvad skal lederen sige?</b>`,
		hintText: `Det peger dem tydeligt mod den konstruktive formulering, uden at sige den direkte eller vredt.`,
		image: 'hhx-it-employees-1',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Den her aftale var slet ikke på tilbud. Det burde du vide',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Hvad tænker du på?! Vi kan da ikke bare give rabat til højre og venstre!',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Hvis du ikke kan finde ud af rabatreglerne, bør du overveje et andet job',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Den aftale var ikke godkendt. Var du klar over det?',
				isCorrect: true
			}),
		],
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'it-employees-2',
		layout: 'management-meeting',
		text: `<b>Direktøren gør klar til møde med bestyrelsen</b>. 
			<br /><br />Hvad er der galt på billedet? 
			<br /><br /><b>Tryk på fejlene. Tryk OK, når I tror, I har dem alle.</b>`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'messy-hair'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'wrong-tie'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'shirt-neck'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'short-shirt'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'buttons'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'upside-down-smile'}),
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'it-employees-3',
		layout: 'management-sales-manager',
		avatarId: 'avatar-1',
		text: `Hvad er vigtigt, at lederen har på og har med, når han eller hun taler med medarbejderne?
			<br /><br /><b>Vælg det, I tror er rigtigt, og tryk OK</b>.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'cigaret', title: 'Cigaret'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'keys', title: 'Nøglebundt'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'future-business-polo', title: 'Future Business A/S Polo', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'pda', title: 'PDA', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'name-tag', title: 'Skilt'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'shorts', title: 'Shorts'
			})
		]
	}),
	/* Case 7 */
	// Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 1,
	// 	taskId: 'education-sort-jobs',
	// 	title: 'Opgave 1A',
	// 	text: `Hvilke jobfunktioner kan vores ansatte søge i andre virksomheder?`,
	// 	categories: [
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'can-apply', 
	// 			title: `Kan søge`
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'cannot-apply', 
	// 			title: `Kan IKKE søge`
	// 		}),
	// 	],
	// 	items: [
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 1, 
	// 			text: `Indkøber`,
	// 			categoryIds: ['can-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 2, 
	// 			text: `Marketingmedarbejder`,
	// 			categoryIds: ['can-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 3, 
	// 			text: `Leder`,
	// 			categoryIds: ['can-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 4, 
	// 			text: `Sælger`,
	// 			categoryIds: ['can-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 5, 
	// 			text: `Sekretær`,
	// 			categoryIds: ['can-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 6, 
	// 			text: `Receptionist`,
	// 			categoryIds: ['can-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 7, 
	// 			text: `Ingeniør`,
	// 			categoryIds: ['cannot-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 8, 
	// 			text: `Advokat`,
	// 			categoryIds: ['cannot-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 9, 
	// 			text: `Lærer`,
	// 			categoryIds: ['cannot-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 10, 
	// 			text: `Revisor`,
	// 			categoryIds: ['cannot-apply']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 11, 
	// 			text: `Elektriker`,
	// 			categoryIds: ['cannot-apply']
	// 		}),
	// 	]
	// }),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 1,
		taskId: 'it-management-knowledge-1',
		title: 'Opgave 1',
		text: `<b>Hvilke afdelinger i Future Business A/S tror I er størst?</b> 
			<br /><br />Sorter dem fra flest til færrest ansatte.`,
		hintText: `Tænk på hvilke opgaver der kræver flest hænder i hverdagen – og hvilke der typisk løses af færre specialister eller ledere.`,
		popupText: `Det her giver indblik i, hvordan en virksomhed typisk er opbygget – noget man også møder på HHX.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Salg`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, 
				text: `Marketing`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, 
				text: `IT`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, 
				text: `Økonomi`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, 
				text: `Ledelse`,
				correctOrderNumbers: [5]
			})
		]
	}),
	Object.assign({}, taskTemplates.pairsTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 2,
		taskId: 'it-management-knowledge-2',
		title: 'Opgave 2',
		text: `<b>Hvad tror I er gennemsnitslønnen i virksomhedens afdelinger?</b>
			<br /><br />Dan par mellem <b>månedsløn</b> og <b>afdeling</b>.`,
		hintText: `Afdelinger med mere ansvar, specialviden eller ledelse ligger typisk højere i løn end dem med mere rutineprægede opgaver.`,
		columnAItems: [
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '52k',
				text: `52.000 kr.`,
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '65k',
				text: '65.000 kr.'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '48k',
				text: `48.000 kr.`
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '58k',
				text: '58.000 kr.'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '55k',
				text: '55.000 kr.'
			}),
		],
		columnBItems: [
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'Marketing',
				text: 'Marketing',
				connectedToItemId: '52k'

			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'management',
				text: 'Ledelse',
				connectedToItemId: '65k'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'sales',
				text: 'Salg',
				connectedToItemId: '48k'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'it',
				text: 'IT',
				connectedToItemId: '58k'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'economy',
				text: 'Økonomi',
				connectedToItemId: '55k'
			})
		]
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'it-management-knowledge-3',
		layout: 'management-office',
		text: `<b>Noget er galt på kontoret.</b>
			<br /><br />Find fejlene og tryk på dem. 
			<br /><br /><b>Tryk OK, når I mener, I har dem alle.</b>`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'messy-papers'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'sitting-on-table'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'open-drawers'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'trash'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'trophy'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'dog'}),
			// Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'books'}),
		]
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'hhxedu-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};